import React, { useState } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ConsultaForm from '../Forms/ConsultaForm';

// Add custom styles for Swiper navigation
const swiperStyles = `
  .swiper-button-next,
  .swiper-button-prev {
    color: white;
    background: rgba(0, 0, 0, 0.5);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    &:after {
      font-size: 24px;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.8);
    }
  }
  .swiper-pagination-bullet {
    background: white;
    opacity: 0.7;
    &-active {
      background: white;
      opacity: 1;
    }
  }
`;

const Hero = () => {
  React.useEffect(() => {
    // Insert custom styles
    const styleSheet = document.createElement("style");
    styleSheet.innerText = swiperStyles;
    document.head.appendChild(styleSheet);
    return () => styleSheet.remove();
  }, []);

  const images = [
    {
      url: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f',
      title: 'Defensa Legal Experta',
      description: 'Protegemos tus derechos con experiencia y dedicación'
    },
    {
      url: 'https://images.unsplash.com/photo-1521791136064-7986c2920216',
      title: 'Asesoramiento Personalizado',
      description: 'Soluciones legales adaptadas a tus necesidades'
    },
    {
      url: 'https://images.unsplash.com/photo-1589578228447-e1a4e481c6c8',
      title: 'Resultados Garantizados',
      description: 'Comprometidos con el éxito de tu caso'
    }
  ];

  const [openConsulta, setOpenConsulta] = useState(false);

  return (
    <Box sx={{ height: '80vh', position: 'relative' }}>
      <Swiper
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        effect="fade"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={800}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        style={{ height: '100%' }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                height: '80vh',
                backgroundImage: `url(${image.url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.7))',
                }}
              />
              <Container
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  position: 'relative',
                  zIndex: 2,
                  color: 'white',
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { xs: '2.5rem', md: '4.5rem' },
                    fontWeight: 'bold',
                    mb: 4,
                    textShadow: '3px 3px 6px rgba(0,0,0,0.5)',
                    letterSpacing: '1px',
                  }}
                >
                  {image.title}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    mb: 6,
                    fontSize: { xs: '1.2rem', md: '1.8rem' },
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                    maxWidth: '800px',
                    lineHeight: 1.4,
                  }}
                >
                  {image.description}
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => setOpenConsulta(true)}
                  sx={{
                    bgcolor: 'white',
                    color: 'primary.main',
                    px: 6,
                    py: 2,
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    '&:hover': {
                      bgcolor: 'primary.main',
                      color: 'white',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 8px rgba(0,0,0,0.2)',
                    },
                  }}
                >
                  CONSULTA GRATUITA
                </Button>
              </Container>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
      <ConsultaForm 
        open={openConsulta} 
        onClose={() => setOpenConsulta(false)} 
      />
    </Box>
  );
};

export default Hero;